import { render, staticRenderFns } from "./UnidadDetalle.vue?vue&type=template&id=5880a3c8&scoped=true"
import script from "./UnidadDetalle.vue?vue&type=script&lang=js"
export * from "./UnidadDetalle.vue?vue&type=script&lang=js"
import style0 from "./UnidadDetalle.vue?vue&type=style&index=0&id=5880a3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880a3c8",
  null
  
)

export default component.exports